export default __webpack_public_path__ + "static/Wearable-technology-60fb2a9595b3bc71dd989e76bd6fcbca.webp";